import { Outlet } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { BuilderOverlay } from '@printtat/builder';
import { adminBuilderApi } from '@/services/adminBuilderApi';

export const AdminLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <AdminSidebar />
      <div className="flex-1">
        <Outlet />
      </div>
      <BuilderOverlay api={adminBuilderApi} />
    </div>
  );
};
